import React, { useEffect } from 'react';

const useOutsideClickListener = (
  overlayRef: React.RefObject<any>,
  callback: (event: any) => void,
  active: boolean,
  triggeringElementRef?: React.RefObject<any>
) => {
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (!active) {
        return;
      }
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        if (
          !triggeringElementRef ||
          !triggeringElementRef.current?.contains(event.target)
        ) {
          callback(event);
        }
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [active, overlayRef, triggeringElementRef, callback]);
};

export default useOutsideClickListener;
